import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { close as dispatchClose } from '../../../modules/modal/actions';
import Translation from '../../i18n/Translation';

const mapDispatchToProps = {
  close: dispatchClose
};

const TransferInfo = ({ close }) => (
  <div className="modal modal--zero-padding">
    <div className="transfer-info modal__content-scrollable">
      <h3 className="modal__sub-header">
        Why can’t I transfer winnings from my bet into my online account balance?
      </h3>
      <p className="modal__paragraph">
        To transfer winnings to your online account, you must have first linked up your Plus account
        to an active William Hill online account. Even if you have done this, there are some
        situations when you will not be given the option to transfer your winnings, or your request
        to transfer winnings is declined as detailed below.
      </p>
      <p className="modal__paragraph">
        You are only permitted to transfer winnings from bets which have been paid for with cash
        loaded onto the SSBT terminal. Winnings from any bets which came from a balance loaded at
        the counter from a debit card, or credited onto the terminal by scanning a cash
        voucher/winning slip are not permitted to be transferred to your online balance.
      </p>
      <p className="modal__paragraph">
        Winnings from cash bets placed on the SSBT which are transferred to your online account
        count as a cash deposit. If your bet returns exceed the daily cash deposit limit, currently
        set to £500, you will need to go into a shop to collect it. If by depositing the winnings
        from your bet you exceed the daily (£500) or weekly (£2500) deposit limits your request will
        be declined.
      </p>
      <p className="modal__paragraph">
        You can’t transfer winnings from a bet until EVERY bet on that slip have been fully settled.
        If you have bets still open, you need to wait for all events to be complete before you
        transfer them. When you click on one of the bets, you will be shown the FULL amount in
        winnings on all the bets on the slip and you must transfer all of them at the same time,
        subject to the daily deposit limits detailed above.
      </p>
      <p className="modal__paragraph">
        If there are any restrictions on your account, if you have recently self-excluded from
        online or from retail shops, or your account is not currently active you will not be able to
        transfer any winnings.
      </p>
      <p className="modal__paragraph">
        Technical Issues – There is always a possibility we are experiencing technical problems or
        your device isn’t connected to a stable and strong data/Wi-Fi source. Check everything is
        working OK and try again.
      </p>
      <p className="modal__paragraph">
        If this doesn’t answer your query, please get in touch with our customer relations team
        using the contact details within the support tab in the menu, or visit any one of our shops
        and speak to a member of the shop team who will be happy to help.
      </p>
    </div>
    <div className="transfer-info__footer">
      <Button className="modal__button button--secondary" onClick={close}>
        <Translation section="common" label="close" />
      </Button>
    </div>
  </div>
);

TransferInfo.propTypes = {
  close: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(TransferInfo);
